// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".\\+r1q[data-v-55bbf9eb]{min-height:48px;padding:14px 33px;font-size:15px;font-style:normal;font-weight:500;line-height:20px;letter-spacing:-.23px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "+r1q"
};
module.exports = ___CSS_LOADER_EXPORT___;
